import { i18n } from "@lingui/core";
import type { ReactNode } from "react";
import { useEffect } from "react";
import { useWidgetConfig } from "../../features/customization/hooks/use-widget-config";
import { detectLocale } from "./index";

interface LocaleConfigWrapperProps {
  children: ReactNode;
}

/**
 * Wrapper component that reads locale config from widget config
 * and updates the locale accordingly. Assumes I18nProvider is already
 * provided higher up in the component tree.
 */
export function LocaleConfigWrapper({ children }: LocaleConfigWrapperProps) {
  const { config } = useWidgetConfig();

  // Extract locale config from appearance settings
  const configLocale = config?.appearance?.locale;

  // Update locale when widget config changes
  useEffect(() => {
    if (configLocale) {
      const locale = detectLocale(configLocale);
      if (i18n.locale !== locale) {
        i18n.activate(locale);
        localStorage.setItem("widget-locale", locale);
      }
    }
  }, [configLocale]);

  return <>{children}</>;
}
